import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Row, Table } from "@themesberg/react-bootstrap";
import { useCallback } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { ContactRequestContext } from "../contexts/ContactRequestContext";
import NotFound from "./NotFound";

const ContactRequest = () => {
	const { contactRequest, getAllContactRequest, deleteContactRequest } =
		useContext(ContactRequestContext);

	const handleDeleteContactRequest = (id) => {
		deleteContactRequest(id, () => {
			getAllContactRequest();
		});
	};

	useEffect(() => {
		getAllContactRequest();
	}, []);

	console.log("Miraz: ", contactRequest);

	return (
		<Card className="py-4 my-4">
			<div className="px-5">
				<center>
					<h5 className="mb-4">Contact Requests</h5>
				</center>
				<Row>
					<Col md={12}>
						{contactRequest && contactRequest?.length > 0 && (
							<Table>
								<thead className="thead-light">
									<tr>
										<th className="border-0">#ID</th>
										<th className="border-0 text-center">Property</th>
										<th className="border-0 text-center">Person</th>
										<th className="border-0 text-center">Req. Type</th>
										<th className="border-0 text-center">Phone</th>
										<th className="border-0 text-center">Email</th>
										<th className="border-0 text-center">Address</th>
										<th className="border-0 text-center">Action</th>
									</tr>
								</thead>
								<tbody>
									{contactRequest?.map((contact) => (
										<tr>
											<td className="border-0">{contact?.id}</td>
											<td className="border-0 text-center">{contact?.property_name}</td>
											<td className="border-0 text-center">
												{contact?.contact_person}
											</td>
											<td className="border-0 text-center">{contact?.type}</td>
											<td className="border-0 text-center">{contact?.phone}</td>
											<td className="border-0 text-center">{contact?.email}</td>
											<td className="border-0 text-center">{contact?.address}</td>
											<td className="border-0 text-center">
												<Button
													size="sm"
													variant="dark"
													onClick={() =>
														handleDeleteContactRequest(contact?.id)
													}
												>
													<FontAwesomeIcon icon={faTrash} />
												</Button>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						)}
						{contactRequest && contactRequest?.length <= 0 && (
							<center>
								<NotFound isData={true} />
							</center>
						)}
					</Col>
				</Row>
			</div>
		</Card>
	);
};

export default ContactRequest;
